// src/pages/WayliRawVesselContainers.jsx
import React from "react";
import WayliRawTablePage from "./WayliRawTablePage";

export default function WayliRawVesselContainers() {
  return (
    <WayliRawTablePage
      title="raw_vessel_containers"
      endpoint="/api/public/raw-vessel-containers"
      selectAllByDefault
    />
  );
}
